<template>
  <v-data-table
    :headers="headers"
    :items="items"
    class="elevation-1 table-cursor-hand"
    :items-per-page="15"
    :footer-props="{
      itemsPerPageOptions: [15, 30, -1],
      itemsPerPageText: $t('table.itemsPerPageText')
    }"
    sort-by="created_at"
    v-bind:sort-desc="true"
    @click:row="clickRow"
    :loading="loading"
    :loading-text="$t('table.loading')"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
    </template>
    <template v-slot:item.state="{ item }">
      <div class="d-flex justify-center">
        <ModeratedOperationState
          :state="item.state"
          :finished="item.finished"
          :authorized="item.authorized"
          :form-name="item.form_name"
          display="stepper-text"
          text-variant="userfriendly"
        />
      </div>
    </template>
    <template v-slot:item.created_at="{ item }">
      <v-tooltip top v-if="item.created_at !== undefined">
        <template v-slot:activator="{ on }">
          <span v-on="on">{{ timeDifference(new Date(item.created_at)) }}</span>
        </template>
        <span
          >{{ new Date(item.created_at).toISOString().substr(0, 10) }}
          {{ new Date(item.created_at).toTimeString().substr(0, 8) }}</span
        >
      </v-tooltip>
    </template>
    <template v-slot:item.form_name="{ item }">
      <span>{{$t(item.object_type + '.title')}} - {{ getFormName(item.form_name) }}</span>
    </template>
  </v-data-table>
</template>

<script>
import investigatorTablesMethods from "../../mixins/investigatorTablesMethods";
import ModeratedOperationState from "../reusables/ModeratedOperationState";
export default {
  mixins: [investigatorTablesMethods],
  components: { ModeratedOperationState },
  props: {
    title: String,
    items: Array,
    headers_2: Array,
    loading: Boolean
  },
  computed: {
    headers() {
      if (this.headers_2 !== undefined) {
        return this.headers_2;
      } else {
        return [
          { text: this.$t("state.state"), value: "state", align: "center" },
          { text: this.$t("name"), value: "title"},
          { text: this.$t("formName"), value: "form_name"},
          { text: this.$t("create"), value: "created_at"}
        ];
      }
    }
  },

  methods: {
    clickRow(item) {
      let path;
      if (item.state === "IN" && item.form_name !== "deleteRequest") {
        path = `/my-forms/${item.object_type}/${item.form_name}/${item.id}`;
      } else if (item.form_name !== "deleteRequest") {
        path = `/my-forms/${item.object_type}/see/${item.form_name}/${item.id}`;
      } else {
        path = `/my-forms/${item.object_type}/delete/see/${item.id}`;
      }
      this.$router.push({
        path: path
      });
    }
  }
};
</script>

<style scoped></style>
